// src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export default function ProtectedRoute({ children, tipoRichiesto }) {
    const [loading, setLoading] = useState(true);
    const [autorizzato, setAutorizzato] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (utente) => {
            if (utente) {
                try {
                    const snap = await getDoc(doc(db, 'utenti', utente.uid));
                    const dati = snap.data();
                    if (!tipoRichiesto || (dati && dati.tipo === tipoRichiesto)) {
                        setAutorizzato(true);
                    } else {
                        setAutorizzato(false);
                    }
                } catch {
                    setAutorizzato(false);
                }
            } else {
                setAutorizzato(false);
            }
            setLoading(false);
        });
        return () => unsubscribe();
    }, [tipoRichiesto]);

    if (loading) return null;
    return autorizzato ? children : <Navigate to="/login" />;
}
